import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import FromFieldSelect from '../../atoms/FromFieldSelect';
import FromFieldDate from '../../atoms/FromFieldDate';
import { getCompanyProfileList } from '../../services/user.service';
import { getYearNameInfo, saveYearName } from '../../services/asset.service';
import * as CryptoJS from "crypto-js";

const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]{1,155}$/;

function getFormatedDate(dateString) {
    if (!dateString) return '';
    let dte = new Date(dateString);
    if (isNaN(dte.getTime())) return dateString;
    let year = dte.getFullYear();
    let month = String(dte.getMonth() + 1).padStart(2, '0');
    let day = String(dte.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

function AddTypeYearOfAddition() {
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState('');

    const [companyId, setCompanyId] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState('');

    const [yearname, setYearName] = useState('');
    const [ErrYearName, setErrYearName] = useState('');

    const [selectedYear, setSelectedYear] = useState('');
    const [ErrYearShortCode, setErrShortCode] = useState('');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // Module Visibility Toggles (Default: Yes)
    const [showInAddition, setShowInAddition] = useState('Yes');
    const [showInDepreciation, setShowInDepreciation] = useState('Yes');
    const [showInItDepreciation, setShowInItDepreciation] = useState('Yes');
    const [showInAllocation, setShowInAllocation] = useState('Yes');
    const [showInCapitalization, setShowInCapitalization] = useState('Yes');
    const [showInFlag, setShowInFlag] = useState('Yes');
    const [showInBranchTransfer, setShowInBranchTransfer] = useState('Yes');
    const [showInDisposal, setShowInDisposal] = useState('Yes');
    const [showInQr, setShowInQr] = useState('Yes');
    const [showInIr, setShowInIr] = useState('Yes');
    const [showInEr, setShowInEr] = useState('Yes');
    const [showInPv, setShowInPv] = useState('Yes');

    const [companies, setCompanies] = useState([]);
    const currentYear = new Date().getFullYear();

    const resetForm = function () {
        setYearName('');
        setCompanyId('');
        setSelectedYear('');
        setStartDate('');
        setEndDate('');
        setShowInAddition('Yes');
        setShowInDepreciation('Yes');
        setShowInItDepreciation('Yes');
        setShowInAllocation('Yes');
        setShowInCapitalization('Yes');
        setShowInFlag('Yes');
        setShowInBranchTransfer('Yes');
        setShowInDisposal('Yes');
        setShowInQr('Yes');
        setShowInIr('Yes');
        setShowInEr('Yes');
        setShowInPv('Yes');
    };

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const YearID = query.get('yearid');

    useEffect(() => {
        if (YearID !== '' && YearID != null) {
            try {
                const decryptedBytes = CryptoJS.AES.decrypt(YearID.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const yearListId = decrypt_data.yearId;
                getYearData(yearListId);
            } catch (e) {
                console.error("Error decrypting YearID:", e);
            }
        }

        const EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        const oData = { 'token': EncryptData };
        getCompanyProfileList(oData).then(res => {
            if (res?.data?.data?.length) {
                setCompanies(res.data.data);
                if (!companyId) {
                    setCompanyId(res.data.data[0].company_id);
                }
            }
        });
    }, [YearID]);

    const getYearData = function (yearListId) {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'yearId': yearListId },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = { 'token': EncryptData };
        getYearNameInfo(oData1).then(function (res) {
            if (res?.data?.data && res.data.data.length > 0) {
                var info = res.data.data[0];
                setCompanyId(info.company_id || '');
                setYearName(info.year_of_addition || '');
                setSelectedYear(info.year_short_name || '');
                setStartDate(info.start_date ? getFormatedDate(info.start_date) : '');
                setEndDate(info.end_date ? getFormatedDate(info.end_date) : '');
                setShowInAddition(info.show_in_addition || 'Yes');
                setShowInDepreciation(info.show_in_depreciation || 'Yes');
                setShowInItDepreciation(info.show_in_it_depreciation || 'Yes');
                setShowInAllocation(info.show_in_allocation || 'Yes');
                setShowInCapitalization(info.show_in_capitalization || 'Yes');
                setShowInFlag(info.show_in_flag || 'Yes');
                setShowInBranchTransfer(info.show_in_branch_transfer || 'Yes');
                setShowInDisposal(info.show_in_disposal || 'Yes');
                setShowInQr(info.show_in_qr || 'Yes');
                setShowInIr(info.show_in_ir || 'Yes');
                setShowInEr(info.show_in_er || 'Yes');
                setShowInPv(info.show_in_pv || 'Yes');
            }
        });
    };

    const handleCompanyId = (e) => {
        setCompanyId(e.target.value);
        setErrCompanyId('');
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
        setErrShortCode('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let valid = true;

        if (!companyId || String(companyId).trim() === '') {
            setErrCompanyId('Company is required');
            valid = false;
        } else {
            setErrCompanyId('');
        }

        if (!yearname || !TEXT_REGEX.test(yearname)) {
            setErrYearName('Year name is required');
            valid = false;
        } else {
            setErrYearName('');
        }

        if (!selectedYear || String(selectedYear).trim() === '') {
            setErrShortCode('Year short code is required');
            valid = false;
        } else {
            setErrShortCode('');
        }

        if (valid) {
            saveData();
        }
    };

    const saveData = function () {
        try {
            var obj = {
                'year_short_name': selectedYear,
                'year_of_addition': yearname,
                'company_id': companyId,
                'start_date': startDate ? getFormatedDate(startDate) : '',
                'end_date': endDate ? getFormatedDate(endDate) : '',
                'show_in_addition': showInAddition,
                'show_in_depreciation': showInDepreciation,
                'show_in_it_depreciation': showInItDepreciation,
                'show_in_allocation': showInAllocation,
                'show_in_capitalization': showInCapitalization,
                'show_in_flag': showInFlag,
                'show_in_branch_transfer': showInBranchTransfer,
                'show_in_disposal': showInDisposal,
                'show_in_qr': showInQr,
                'show_in_ir': showInIr,
                'show_in_er': showInEr,
                'show_in_pv': showInPv,
                'status': '1',
                'created_by': sessionStorage.getItem('LoggedInUserId'),
            };

            if (YearID !== '' && YearID !== null) {
                const decryptedBytes = CryptoJS.AES.decrypt(YearID.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                obj.year_id = decrypt_data.yearId;
            }

            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

            let oData = { 'token': EncryptData };

            saveYearName(oData).then(function (res) {
                if (res.data?.errors && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message || 'Error saving data');
                    setSuccess('');
                } else {
                    setSuccess(res.data?.message || 'Year of addition saved successfully');
                    setErrMsg('');
                    resetForm();
                }
            });
        } catch (err) {
            setSuccess('');
            setErrMsg('Insert/Update Failed');
        }
    };

    const moduleToggles = [
        { label: 'Do you want to show in Addition', value: showInAddition, setter: setShowInAddition, highlighted: true },
        { label: 'Do you want to show in Depreciation', value: showInDepreciation, setter: setShowInDepreciation, highlighted: true },
        { label: 'Do you want to show in IT Depreciation', value: showInItDepreciation, setter: setShowInItDepreciation, highlighted: true },
        { label: 'Do you want to show in Allocation', value: showInAllocation, setter: setShowInAllocation },
        { label: 'Do you want to show in Capitalization', value: showInCapitalization, setter: setShowInCapitalization, highlighted: true },
        { label: 'Do you want to show in Flag', value: showInFlag, setter: setShowInFlag },
        { label: 'Do you want to show in Branch Transfer', value: showInBranchTransfer, setter: setShowInBranchTransfer },
        { label: 'Do you want to show in Disposal', value: showInDisposal, setter: setShowInDisposal },
        { label: 'Do you want to show in QR', value: showInQr, setter: setShowInQr },
        { label: 'Do you want to show in IR', value: showInIr, setter: setShowInIr },
        { label: 'Do you want to show in ER', value: showInEr, setter: setShowInEr },
        { label: 'Do you want to show in PV', value: showInPv, setter: setShowInPv },
    ];

    return (
        <div className="al-page" id="add-year-of-addition-page">
            {/* Header */}
            <div className="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-calendar-plus-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">{YearID ? 'Edit Year Of Addition' : 'Add Year Of Addition'}</h5>
                        <p className="al-page-subtitle">Configure financial year parameters and module display visibility</p>
                    </div>
                </div>
            </div>

            {/* Notifications */}
            {success && (
                <div className="alert alert-success d-flex align-items-center mb-3" role="alert">
                    <i className="bi bi-check-circle-fill me-2 fs-5" />
                    <div>{success}</div>
                </div>
            )}
            {errMsg && (
                <div className="alert alert-danger d-flex align-items-center mb-3" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2 fs-5" />
                    <div>{errMsg}</div>
                </div>
            )}

            <form onSubmit={handleSubmit}>
                {/* Section 1: Basic Information */}
                <div className="card shadow-sm mb-4" style={{ borderRadius: '10px', border: '1px solid #e0e0e0' }}>
                    <div className="card-header bg-light py-2 px-3" style={{ borderBottom: '1px solid #e0e0e0' }}>
                        <strong style={{ color: '#2c3e50', fontSize: '15px' }}>
                            <i className="bi bi-info-circle-fill me-2 text-primary" /> Basic Information
                        </strong>
                    </div>
                    <div className="card-body p-4">
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label font-weight-bold">
                                    Company <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select"
                                    value={companyId}
                                    onChange={handleCompanyId}
                                    style={{ borderRadius: '6px', height: '42px' }}
                                >
                                    <option value="">Select Company</option>
                                    {companies && companies.length > 0 ? (
                                        companies.map((option) => (
                                            <option key={option.company_id} value={option.company_id}>
                                                {option.company_name}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="">No Company Data</option>
                                    )}
                                </select>
                                {ErrCompanyId && <small className="text-danger mt-1 d-block">{ErrCompanyId}</small>}
                            </div>

                            <div className="col-md-6 mb-3">
                                <FromFieldText
                                    star="*"
                                    label="Year Name"
                                    placeholder="e.g. FY2027"
                                    inputValue={yearname}
                                    setInputValue={setYearName}
                                    setErrorMsg={ErrYearName}
                                />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-4 mb-3">
                                <label className="form-label font-weight-bold" style={{ backgroundColor: '#fff9c4', padding: '2px 6px', borderRadius: '4px' }}>
                                    Select Year Short Code <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select"
                                    value={selectedYear}
                                    onChange={handleYearChange}
                                    style={{ borderRadius: '6px', height: '42px' }}
                                >
                                    <option value="">Select Year</option>
                                    {Array.from({ length: 35 }, (_, i) => 2000 + i).map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                                {ErrYearShortCode && <small className="text-danger mt-1 d-block">{ErrYearShortCode}</small>}
                            </div>

                            <div className="col-md-4 mb-3">
                                <FromFieldDate
                                    label="Start Date"
                                    placeholder="Select Start Date"
                                    inputValue={startDate}
                                    setInputValue={setStartDate}
                                />
                            </div>

                            <div className="col-md-4 mb-3">
                                <FromFieldDate
                                    label="End Date"
                                    placeholder="Select End Date"
                                    inputValue={endDate}
                                    setInputValue={setEndDate}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section 2: Module Display Settings */}
                <div className="card shadow-sm mb-4" style={{ borderRadius: '10px', border: '1px solid #e0e0e0' }}>
                    <div className="card-header bg-light py-2 px-3" style={{ borderBottom: '1px solid #e0e0e0' }}>
                        <strong style={{ color: '#2c3e50', fontSize: '15px' }}>
                            <i className="bi bi-toggle-on me-2 text-primary" /> Module Display Settings
                        </strong>
                    </div>
                    <div className="card-body p-4">
                        <div className="row">
                            {moduleToggles.map((item, idx) => (
                                <div className="col-md-6 mb-3" key={idx}>
                                    <div
                                        className="p-2 px-3 rounded d-flex align-items-center justify-content-between"
                                        style={{
                                            backgroundColor: item.highlighted ? '#fffde7' : '#f8f9fa',
                                            border: item.highlighted ? '1px solid #ffe082' : '1px solid #e9ecef',
                                            borderRadius: '6px'
                                        }}
                                    >
                                        <label className="form-label m-0 me-2" style={{ fontSize: '14px', fontWeight: item.highlighted ? '600' : '400' }}>
                                            {item.label}
                                        </label>
                                        <div style={{ minWidth: '100px' }}>
                                            <select
                                                className="form-select form-select-sm font-weight-bold"
                                                value={item.value}
                                                onChange={(e) => item.setter(e.target.value)}
                                                style={{ borderRadius: '6px', height: '36px', cursor: 'pointer' }}
                                            >
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Submit Action */}
                <div className="row mb-5">
                    <div className="col-12 text-end">
                        <a href="/division/list-type-year-of-addition" className="btn btn-secondary me-2 px-4">
                            Cancel
                        </a>
                        <button type="submit" className="btn btn-primary px-5 font-weight-bold" style={{ borderRadius: '6px', height: '42px' }}>
                            <i className="bi bi-save me-2" /> SAVE
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default AddTypeYearOfAddition;
